import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Cpu, Users, Code2, Layers } from 'lucide-react'
import { Card, CardContent } from '../ui/card'

interface Service {
    key: string
    nameKey: string
    summaryKey: string
    linkKey: string
    to: string
    Icon: typeof Cpu
}

const services: Service[] = [
    { key: 'compute', nameKey: 'services.compute.name', summaryKey: 'services.compute.summary', linkKey: 'services.seePricing', to: '/pricing', Icon: Cpu },
    { key: 'consulting', nameKey: 'services.consulting.name', summaryKey: 'services.consulting.summary', linkKey: 'services.learnMore', to: '/documentation', Icon: Users },
    { key: 'sdk', nameKey: 'services.sdk.name', summaryKey: 'services.sdk.summary', linkKey: 'services.learnMore', to: '/documentation', Icon: Code2 },
    { key: 'terraform', nameKey: 'services.terraform.name', summaryKey: 'services.terraform.summary', linkKey: 'services.learnMore', to: '/documentation', Icon: Layers },
]

const Services = () => {
    const { t } = useTranslation()

    return (
        <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold tracking-tight">{t('services.title')}</h2>
                <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">{t('services.subtitle')}</p>
            </div>
            <div className="grid gap-6 sm:grid-cols-2">
                {services.map(({ key, nameKey, summaryKey, linkKey, to, Icon }) => (
                    <Card key={key} className="transition-shadow hover:shadow-md">
                        <CardContent className="flex items-start gap-4 p-6">
                            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary/10">
                                <Icon className="h-6 w-6 text-primary" />
                            </div>
                            <div className="min-w-0 flex-1">
                                <h3 className="text-xl font-semibold">{t(nameKey)}</h3>
                                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{t(summaryKey)}</p>
                                <Link to={to} className="mt-3 inline-block text-sm font-medium text-primary hover:underline">
                                    {t(linkKey)}
                                </Link>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </section>
    )
}

export default Services
